import type { ShowToastOptions } from '@ztechapps/common.hook'
import type { Dispatch, SetStateAction } from 'react'
import type { IToastAction } from './IToastAction'
import merge from 'lodash/merge'

export class ToastActionBase implements IToastAction {
  constructor(protected showToastOptions: ShowToastOptions, protected setShowToastOptions: Dispatch<SetStateAction<ShowToastOptions>>) {}

  showToast(options?: ShowToastOptions) {
    this.setShowToastOptions(merge({ ...this.showToastOptions, ...options, show: true }))
  }

  showError(options?: ShowToastOptions) {
    this.showToast(merge({ ...options, type: 'danger' }))
  }
  showSuccess(options?: ShowToastOptions) {
    this.showToast(merge({ ...options, type: 'success' }))
  }
  showInfo(options?: ShowToastOptions) {
    this.showToast(merge({ ...options, type: 'info' }))
  }
  showWarning(options?: ShowToastOptions) {
    this.showToast(merge({ ...options, type: 'warning' }))
  }

  showNotification(message: string): void {
    this.showToast({ message, type: 'default' })
  }
}
